<template>
  <v-card elevation="2" class="ml-5 mr-5 mt-5 mb-5">
    <v-data-table
      :headers="headers"
      :items="productCategoryItems"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Kategori Produk</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px" persistent>
            <!-- <template v-if="permission.includes('Create Kategori Produk')" v-slot:activator="{ on }"> -->
            <template v-if="role == 'stockiest'" v-slot:activator="{ on }">
              <v-btn
                color="primary"
                small
                dark
                class="mb-2"
                v-on="on"
                @click="[(dialog = true)]"
                >Buat Kategori Produk</v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" md="12">
                    <v-text-field
                      v-model="editedItem.name"
                      label="Nama Kategori Produk"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <v-col cols="12" sm="6" md="12">
                    <v-select
                      v-model="editedItem.type"
                      :items="['PEMASUKAN', 'PENGELUARAN']"
                      label="Tipe Produk"
                      required
                    ></v-select>
                  </v-col>
                </v-row> -->
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close()"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="save()">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="productImageModal" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="headline">Gambar Produk Kategori</span>
              </v-card-title>
              <v-card-text class="text-center">
                <v-row v-if="listProductImages.length < 6">
                  <v-col cols="12" sm="6" md="12">
                    <v-file-input
                      accept="image/*"
                      label="Tambah Gambar Produk"
                      outlined
                      dense
                      hide-details="true"
                      ref="uploadImage"
                      @change="onUploadImage()"
                      v-model="fileGambarProduk"
                    ></v-file-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    v-for="image in listProductImages"
                    :key="image.id"
                    cols="6"
                    sm="3"
                    md="6"
                  >
                    <v-avatar tile size="100">
                      <img
                        class="pointer"
                        @click="
                          onClickImage(
                            baseUrl + '/' + image.location + '/' + image.name
                          )
                        "
                        :src="baseUrl + '/' + image.location + '/' + image.name"
                        alt="Product Images"
                      />
                    </v-avatar>
                    <br />
                    <v-btn
                      text
                      small
                      @click="onRemoveImage(image.id)"
                      color="error"
                      >Hapus Gambar Produk</v-btn
                    >
                    <!-- <v-btn text small @click="onRemoveImageProfile()" color="error">Hapus Foto Profil</v-btn> -->
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.no`]="{ item }">
        {{ productCategoryItems.indexOf(item) + 1 + "." }}
      </template>
      <template v-slot:no-data>
        <span class="text-center">No data available.</span>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <template v-if="role == 'stockiest'">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <!-- <v-icon v-on="on" small class="mr-2" v-if="permission.includes('Update Kategori Produk')" @click="editItem(item)">edit</v-icon> -->
              <v-icon
                v-on="on"
                v-if="item.name != 'UNCATEGORIZED'"
                small
                class="mr-2"
                @click="editItem(item)"
                >edit</v-icon
              >
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <!-- <v-icon v-on="on" small class="mr-2" v-if="permission.includes('Delete Kategori Produk')" @click="deleteItem(item)">delete</v-icon> -->
              <v-icon
                v-on="on"
                v-if="item.name != 'UNCATEGORIZED'"
                small
                class="mr-2"
                @click="deleteItem(item)"
                >delete</v-icon
              >
            </template>
            <span>Hapus</span>
          </v-tooltip>
          <v-tooltip v-if="role === 'stockiest'" top>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" v-on="on" @click="addImage(item)"
                >image</v-icon
              >
            </template>
            <span>Tambah Gambar</span>
          </v-tooltip>
        </template>
        <template v-else>
          <span>-</span>
        </template>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import forEach from "lodash/forEach";
import slice from "lodash/slice";
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";
import itemTemplate from "@/components/ItemTemplate.vue";
export default {
  data: () => ({
    itemTemplate,
    dialog: false,
    expand: false,
    role: "",
    permission: [],
    showError: false,
    headers: [
      {
        text: "No.",
        align: "left",
        value: "no",
      },
      { text: "Kategori Product", value: "name" },
      { text: "Actions", align: "center", value: "action", sortable: false },
    ],
    productCategoryItems: [],
    item: "",
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    productImageModal: false,
    listProductImages: [],
    selectedCategoryProduct: null,
    fileGambarProduk: null,
    baseUrl: process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL,
  }),

  computed: {
    ...mapGetters({}),

    formTitle() {
      return this.editedIndex === -1
        ? "Buat Kategori Product"
        : "Edit Kategori Product";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions({
      getProductCategories: "product_categories/getProductCategories",
      createProductCategories: "product_categories/createProductCategories",
      updateProductCategories: "product_categories/updateProductCategories",
      deleteProductCategories: "product_categories/deleteProductCategories",
      getCategoryProductById: "product_categories/getCategoryProductById",
      uploadImage: "product_categories/uploadImage",
      removeImage: "product_categories/removeImage",
    }),
    async initialize() {
      const userLogin = JSON.parse(window.localStorage.getItem("user_data"));
      this.role = userLogin.roles[0].name;
      this.permission = userLogin.permissions;
      const dataItem = await this.getProductCategories();
      // console.log('dataItem', dataItem)

      await forEach(dataItem.data, (data) => {
        this.productCategoryItems.push(data);
      });
    },

    editItem(data) {
      this.editedIndex = this.productCategoryItems.indexOf(data);
      this.editedItem = Object.assign({}, data);
      this.dialog = true;
    },

    async deleteItem(item) {
      const index = this.productCategoryItems.indexOf(item);
      if (confirm("Apakah anda yakin menghapus kategori product ini?")) {
        const response = await this.deleteProductCategories(item.id);
        if (response.status == 200) {
          this.productCategoryItems.splice(index, 1);
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: `Sukses menghapus kategori produk ${item.name}`,
          });
        }
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    onClickImage(url) {
      window.open(url, "_blank");
    },
    async onRemoveImage(id) {
      try {
        const response = await this.removeImage(id);
        if (response.status === 200) {
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: "Hapus gambar produk berhasil!",
          });

          this.fileGambarProduk = null;
          this.listProductImages = [];
          const responseProduct = await this.getCategoryProductById(
            this.selectedCategoryProduct
          );
          forEach(
            responseProduct.data.data.product_category_attachment,
            (attachment) => {
              this.listProductImages.push(attachment);
            }
          );
        }
      } catch (e) {
        console.log(e);
      }
    },
    async addImage(data) {
      this.listProductImages = [];
      this.selectedCategoryProduct = data.id;

      const response = await this.getCategoryProductById(data.id);

      forEach(response.data.data.product_category_attachment, (attachment) => {
        this.listProductImages.push(attachment);
      });
      this.productImageModal = true;
    },
    async onUploadImage() {
      try {
        if (this.fileGambarProduk != null) {
          const data = new FormData();
          data.append("product_category", this.fileGambarProduk);
          data.append("product_category_id", this.selectedCategoryProduct);

          const response = await this.uploadImage(data);
          if (response.status === 200) {
            this.$notify({
              group: "custom-notification",
              type: "success",
              title: "Success!",
              text: "Upload gambar kategori produk berhasil!",
            });

            this.fileGambarProduk = null;
            this.listProductImages = [];
            const responseProduct = await this.getCategoryProductById(
              this.selectedCategoryProduct
            );
            forEach(
              responseProduct.data.data.product_category_attachment,
              (attachment) => {
                this.listProductImages.push(attachment);
              }
            );
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async save() {
      try {
        if (this.editedIndex > -1) {
          const response = await this.updateProductCategories(this.editedItem);
          if (response.status == 200) {
            Object.assign(
              this.productCategoryItems[this.editedIndex],
              response.data.data
            );
            this.$notify({
              group: "custom-notification",
              type: "success",
              title: "Success!",
              text: `Sukses memperbarui kategori produk ${response.data.data.name}`,
            });
          }
        } else {
          const response = await this.createProductCategories(this.editedItem);
          if (response.status == 200) {
            this.productCategoryItems.splice(0, 0, response.data.data);
            this.$notify({
              group: "custom-notification",
              type: "success",
              title: "Success!",
              text: `Sukses membuat kategori produk ${response.data.data.name}`,
            });
          }
        }
        this.close();
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
<style>
.vue-suggestion .vs__input {
  width: 100%;
  text-align: left;
  border-bottom: 1px solid black;
  max-height: 400px;
  overflow-y: auto;
  font-size: 16px;
  color: black;
  position: relative;
}
.vue-suggestion .vs__list {
  width: 100%;
  text-align: left;
  border: none;
  border-top: none;
  max-height: 400px;
  overflow-y: auto;
  border-bottom: 1px solid #023d7b;
  position: relative;
}
.vue-suggestion .vs__list .vs__list-item {
  position: relative;
  z-index: 1;
  background-color: #fff;
  padding: 10px;
  border-left: 1px solid #023d7b;
  border-right: 1px solid #023d7b;
}
.vue-suggestion .vs__list .vs__list-item:last-child {
  border-bottom: none;
}
.vue-suggestion .vs__list .vs__list-item:hover {
  background-color: #eee !important;
}
.vue-suggestion .vs__list,
.vue-suggestion .vs__loading {
  position: absolute;
}
.vue-suggestion .vs__list .vs__list-item {
  cursor: pointer;
}
.vue-suggestion .vs__list .vs__list-item.vs__item-active {
  background-color: #f3f6fa;
}
</style>